export function isValidEmail(email: string | null) {
  if (email == null) {
    return false;
  }
  return email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/) !== null;
}
